export interface IQueryBuilder {
  return_mode: EnumReturnMode | null;
  type?: EnumQueryBuilderType | null;
  children: IQueryBuilderChild[];
}

export interface IQueryBuilderChild {
  logical_operator: EnumLogicalOperator | null;
  query: {
    query_value: string | null;
    query_column?: any | null;
    operator: EnumQueryOperators | null,
    operand: object | null,
  };
}

export enum EnumReturnMode {
  RM_ANY = 'RM_ANY',
  RM_ALL = 'RM_ALL',
}

export enum EnumLogicalOperator {
  OP_AND = 'OP_AND',
  OP_OR = 'OP_OR',
}


export enum EnumQueryBuilderType {
  FIELD = 'FIELD',
  SEARCH_ENGINE = 'SEARCH_ENGINE',
  QUERY_BUILDER_FILTER = 'QUERY_BUILDER_FILTER',
}

export enum EnumQueryOperators {
  OP_EQUAL = 'OP_EQUAL',
  OP_NOT_EQUAL = 'OP_NOT_EQUAL',
  OP_CONTAINS = 'OP_CONTAINS',
  OP_NOT_CONTAINS = 'OP_NOT_CONTAINS',
  OP_BETWEEN = 'OP_BETWEEN',
  OP_NOT_BETWEEN = 'OP_NOT_BETWEEN',
  OP_IN = 'OP_IN',
  OP_NOT_IN = 'OP_NOT_IN',
  OP_GREATER = 'OP_GREATER',
  OP_GREATER_EQUAL = 'OP_GREATER_EQUAL',
  OP_LESSER = 'OP_LESSER',
  OP_LESSER_EQUAL = 'OP_LESSER_EQUAL',
}
